import React from 'react/addons';
import {FluxMixin} from 'fluxxor';
import cx from 'classnames';


var ModalOverlay = React.createClass({
  mixins: [
    React.addons.PureRenderMixin,
    FluxMixin(React)
  ],

  getDefaultProps() {
    return {
      transparent: false
    };
  },

  close() {
    this.getFlux().actions.layers.remove();
  },

  render() {
    var classes = {
      'ofs-ModalOverlay': true,
      'ofs-ModalOverlay--transparent': this.props.transparent
    };

    return (
      <div className={cx(classes)} onClick={this.close} />
    );
  }
});

export default ModalOverlay;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/ModalOverlay.jsx
 **/